module.exports = __webpack_public_path__ + "92d45e568ef7627bc99634002e5cd88c.png";